module.exports = __webpack_public_path__ + "img/spinneys-original-480.9bd7d196.webp";